import React from 'react';
import { Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import RemoveButton from '@/components/buttons/RemoveButton';
import { removeDictionaryFromCohort } from '../../actions';

const QueryDictionaryButtons = ({
  category,
  code,
  queryUUID,
  dictionaryCode,
  removeDictionary,
}) => (
  <Button.Group icon compact floated="right" size="small">
    <RemoveButton
      entity={dictionaryCode ? 'query.dictionary' : 'query.dictionary.unknown'}
      onClick={() => removeDictionary(category, code, queryUUID, dictionaryCode)}
    />
  </Button.Group>
);

const mapDispatchToProps = {
  removeDictionary: removeDictionaryFromCohort,
};

export default connect(null, mapDispatchToProps)(QueryDictionaryButtons);
